import { ApiHeaderInfoOk } from 'src/types/v1-api-types';
import { ErrorBoundary, LinkStyled } from '@components/common';
import { LogoBjFull } from '@components/layout/LogoBj/LogoBjFull';
import { useExtendedRouter } from '@hooks/next-routing-wrappers';
import { getI18nLinkHref } from '@services/i18nPaths';
import { LogoBj } from './LogoBj';

interface LogoBjInterface {
  headerInfo?: ApiHeaderInfoOk;
  locale?: Locale;
  className?: string;
  iconColor?: string;
  textColor?: string;
  width?: string;
  height?: string;
  imageClassName?: string;
  showFullLogo?: boolean;
}

/**
 * @description Bestjobs logo component. Links to the home page regardless of auth state or user
 * role (the home root `/`, which redirects to the Bestie coaching chat).
 */
export const LogoBjLink = (props: LogoBjInterface) => {
  const {
    headerInfo,
    locale: propLocale,
    className = '',
    iconColor = 'fill-secondary',
    textColor = 'fill-ink',
    width = '100%',
    height = '100%',
    imageClassName = '',
    showFullLogo = false,
  } = props;


  // Resolve the active locale and the localized home URL
  const { locale: routerLocale } = useExtendedRouter();
  const usedLocale = (propLocale || routerLocale);
  const homeHref = getI18nLinkHref('/', usedLocale);


  const isCompany = !headerInfo || (headerInfo && headerInfo.role === 'COMPANY');
  const isUser = !headerInfo || (headerInfo && headerInfo.role === 'USER');

  // If the user is authenticated, we need to redirect him to the correct homepage page
  // *******************************************************************************
  if (headerInfo) {
    return (
      <ErrorBoundary
        fallback={<div className="py-1.5 text-xl font-bold">Bestjobs</div>}
      >
        <LinkStyled
          href="/"
          locale={usedLocale}
          aria-label="bestjobs"
          className={className}
          styling="none"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = homeHref;
          }}
        >
          <LogoBj />
        </LinkStyled>
      </ErrorBoundary>
    );
  }

  // If the user is not authenticated, we set the link to the home page or live page.
  // *******************************************************************************
  return (
    <ErrorBoundary
      fallback={<div className="py-1.5 text-xl font-bold">Bestjobs</div>}
    >
      <LinkStyled
        href="/"
        locale={usedLocale}
        aria-label="bestjobs"
        className={className}
        styling="none"
        onClick={(e) => {
          e.preventDefault();
          window.location.href = homeHref;
        }}
      >
        {(isCompany || isUser) && !showFullLogo ? (
          <>
            <LogoBj />
          </>
        ) : (
          <LogoBjFull
            iconColor={iconColor}
            textColor={textColor}
            width={width}
            height={height}
            className={imageClassName}
          />
        )}
      </LinkStyled>
    </ErrorBoundary>
  );
};
